
import Overlay from '../overlay';
import IconButton from '../../icon-button';
import { IconType } from '../../icon/enums';
import { StyleColorSchemeType, StylePositionType, StyleSizeType } from '../../../styles/enums';
import {
  DisplayState,
  ModalPositionType,
  ModalSlotName,
  ModalViewType,
} from '../enums';
import StyleClassNamesBuilder from '../../../styles/helpers/StyleClassNamesBuilder';
import Gutter from '../../gutter';

export default {
  name: 'ModalWindow',
  components: {
    Gutter,
    Overlay,
    IconButton,
  },
  props: {
    showModal: {
      type: Boolean,
      default: true,
    },
    closeHandler: {
      type: Function,
      required: true,
    },
    modalOptions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      IconType,
      StyleColorSchemeType,
      ModalSlotName,
      StylePositionType,
      StyleSizeType,
    };
  },
  computed: {
    showState() {
      return this.showModal ? DisplayState.Opened : DisplayState.Closed;
    },
    modalPosition() {
      return (this.modalOptions && this.modalOptions.position) || ModalPositionType.Center;
    },
    modalView() {
      return (this.modalOptions && this.modalOptions.viewType) || ModalViewType.FitContent;
    },
    modalContentClassNames() {
      return new StyleClassNamesBuilder('modal-window__content')
        .addConditionClassNames(Object.values(ModalPositionType), this.modalPosition)
        .addConditionClassNames(Object.values(ModalViewType), this.modalView)
        .addConditionClassNames(Object.values(DisplayState), this.showState)
        .build();
    },
  },
};
